

import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import AccordionItemCustom from "../components/accordion";
import Helmet from "react-helmet";
import PortfolioApi from "../components/api/portfolio_api";
import {Link} from "react-router-dom";
import SectionProducts from "../components/sections/products";
import {MotionAnimate} from "react-motion-animate";
import Section from "../components/basic/layouts/section";
import * as FaIcons from "react-icons/fa";
import BooksSection from "../components/sections/products/book";
import {FaArrowRight, FaDownload, FaYoutube} from "react-icons/fa";
import CardDownloadProduct from "../components/card/card_product_download";

function ProductsPage(props) {

    const { t, i18n } = useTranslation()

    const _data = [
        {
            type: 'app',
            name: "Random App",
            url:"https://apps.lukyanchuk.com/app/random-app",
            image: "https://storage.lukyanchuk.com/storage/files/portfolio/8ihYr6s9pJUSb7B3BaAFnYzVLskerXkASPJti8aX.png"
        },
        {
            type: 'book',
            name: "Книга 1% Змін",
            content: <BooksSection />,
            url:"https://books.lukyanchuk.com/book/one-percent-changes-do-it-now",
            image: "https://books.lukyanchuk.com/image/cover/book_cover.png"
        },
        {
            type: 'book',
            name: "Блокнот продуктивності",
            content: '',
            url:"https://books.lukyanchuk.com/productivity-notebook/",
            image: "https://books.lukyanchuk.com/image/cover/v1-NOTEBOOK.png"
        },
        {
            type: 'course',
            name: "Курс \"БД FoxPro\"",
            url:"https://www.youtube.com/watch?v=npXoUocYrRE&list=PL6N3szFzf6LsJltveomTuF0I689KjX1-A",
            image: "https://s3-alpha.figma.com/hub/file/2729732820/69ab2bc1-7dda-4bf6-ac0b-adcb3e70b063-cover.png"
        },
        {
            type: 'todo',
            name: "Plugin",
            url:"#",
            image: "https://s3-alpha.figma.com/hub/file/2729732820/69ab2bc1-7dda-4bf6-ac0b-adcb3e70b063-cover.png"
        }
    ];

    //TODO: get api
    const PRODUCTS_API_URL = 'https://api.lukyanchuk.com/api/front-end/projects?products=1&limit=10&sort=DESC';

    const [option, setOption] = useState('book');

    const changeOption = (id) => setOption(id)

    return (<div className={'container h-auto'}>

        <Helmet>
            <title>Products - Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container row m-auto">

            <h1 className={'opacity-25'} style={{fontSize: '17vw'}}>Products</h1>

            <div className="d-flex flex-wrap align-items-center justify-content-center">

                <div className="item p-1 col-auto m-1">
                    <small className={`${option === 'todo' ? 'bg-dark text-white border-0' : 'text-secondary border'} rounded-5 p-2`} onClick={() => changeOption('todo')}>
                        Future Products
                    </small>
                </div>

                <div className="item p-1 col-auto m-1">
                    <small className={`${option === 'book' ? 'bg-dark text-white border-0' : 'text-secondary border'} rounded-5 p-2`} onClick={() => changeOption('book')}>
                        Books
                    </small>
                </div>

                <div className="item p-1 col-auto m-1" onClick={() => changeOption('app')}>
                    <small className={`${option === 'app' ? 'bg-dark text-white border-0' : 'text-secondary border'} rounded-5 p-2`} onClick={() => changeOption('app')}>
                        Apps
                    </small>
                </div>

                <div className="item p-1 col-auto m-2">
                    <small className={`${option === 'course' ? 'bg-dark text-white border-0' : 'text-secondary border'} rounded-5 p-2`} onClick={() => changeOption('course')}>
                        Courses
                    </small>
                </div>
            </div>

            <div className="products-list">
                {
                    _data.filter(a => a.type === option).map((item, i) => <div>
                        <h5>{item.name}</h5>
                        {item.content}
                    </div>)
                }
            </div>

        </div>

        <div className="rounded-5 text-dark" style={{height: '50vh'}}>


            <div id="gift"
                 className="col-md-12 col-12 d-flex justify-content-between align-items-start bg-dark rounded-5 shadow-lg p-md-5 p-4">
                <div className="col-md-8 p-md-5 p-0">
                    <div>
                        <div style={{opacity: "1", transform: "none"}}><h2
                            className="custom-heading display-md-4 display-5 text-white w-auto"><b>Блокнот
                            продуктивності</b></h2></div>
                    </div>
                    <div>
                        <div style={{opacity: "1", transform: "none"}}><p
                            className="p-md-2 p-0 display- text-white">Блокнот підвищіть твою
                            продуктивність, дасть тобі змогу сфокусуватись на дійсно потрібних для
                            тебе речех та справах, відкинувши все зайве.</p></div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-8 col-12">
                            <div>
                                <div style={{opacity: "1", transform: "none"}}>
                                    <div className="row"><a
                                        href="https://docs.google.com/forms/d/e/1FAIpQLSc5nJLkAQ1NBxCQc3JC4oYBjWcGLiCmqa_KU1swwCUy1XUx9w/viewform?usp=sf_link"
                                        className="btn btn-outline-light shadow-lg bg-dark text-white p-2 pt-3 pb-3 col-md-8 col-12 rounded-5"><span
                                        className="lead display-">Отримати</span></a><a
                                        href="/NOTEBOOK_template.pdf"
                                        className="btn text-white p-2 pt-3 pb-3 col-md-4 col-12 rounded-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                             height="16" fill="currentColor"
                                             className="bi bi-download" viewBox="0 0 16 16">
                                            <path
                                                d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"></path>
                                            <path
                                                d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"></path>
                                        </svg>
                                        <small className={'p-2'}>шаблон</small></a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 d-none d-md-block text-center">
                    <MotionAnimate
                        animation='fadeInUp'
                        reset={true}
                        distance={100}
                        delay={1}
                        speed={1}>
                        <div style={{opacity: "1", transform: "none"}}><img
                            src="https://static.vecteezy.com/system/resources/previews/009/376/176/original/3d-black-book-illustration-png.png"
                            height="350" alt="photo" className="img-fluid1 rounded" /></div>
                    </MotionAnimate>
                </div>
            </div>
        </div>

        <div className="border rounded-5 p-3 mb-5">
            <CardDownloadProduct />
        </div>

    </div>);
}

export default ProductsPage;
